<template>
  <transition name="fade">
    <div name="fade" class="pop-up fixed-top" @click.self="close">
      <div class="pop-box container" :class="{'small-pop': size==='small', 'middle-pop': size==='middle', 'large-pop': size==='large'}">
        <div class="row p-2">
          <div class="col-12">
            <font-awesome-icon class="pointer" @click="close" size="2x" :icon="['fa', 'times']"  style="color:rgba(255, 0, 0, .6);float: right;"/>
          </div>
          </div>
          <div class="col-12 p-3">
            <div class="pop-edge row">
              <div class="col-12">
                <slot  name="title">
                </slot>
              </div>
              <div class="col-12">
                <slot  name="info">
                </slot>
              </div>
              <div class="col-md-6">
                <slot name="left-box">
                </slot>
              </div>
              <div class="col-md-6">
                <slot name="right-box">
                </slot>
              </div>
              <!-- <hr> -->
              <div class="col-12">
                <slot name="vocabulary">
                </slot>
              </div>
              <div class="col-12">
                <slot name="feedback">
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Pop-up',
  data () {
    return {

    }
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'middle'
    }
  },
  methods: {
    close () {
      this.$emit('doClose', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/custom.scss";
  .pop-up {
    text-align: left;
    width: 100%;
    height: 100vh;
    background-color: #000000ad !important;
    z-index: 500;
    .pop-box {
      @include center();
      min-height: 200px;
      max-height: 90%;
      border-radius: 20px;
      // overflow: auto;
      z-index: 100;
      background-color: rgb(255, 255, 255);
      .pop-edge {
        //height: 680px;
        overflow: auto;
      }
    }
  }
  .small-pop {
    max-width: 500px !important;
  }
  .middle-pop {
    max-width: 800px !important;
  }
  .large-pop {
    max-width: 1100px !important;
    min-height: 700px!important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  hr {
    // border: 0;
    border-bottom:  1px solid black;
  }
  @media
  (max-height: 680px) {
    .pop-box {
      max-height: 100% !important;
    }
  }
  @media (max-height: 680px) {
    .pop-edge {
      overflow: auto;
      //height: 450px !important;
    }
  }
</style>
